export default __webpack_public_path__ + "static/media/youtube_white_logo.105e70be.svg";